export const APP_VERSION = 'admin-2026.09.06.205700';
export const APP_NAME = 'admin';
